import React from 'react';
import { createPortal } from 'react-dom';

/**
 * Reusable success overlay (modal) with title, optional message, and action button.
 */
function SuccessOverlay({ open, onClose, title, message, buttonLabel = 'Done' }) {
  if (!open) return null;

  const overlay = (
    <div className="fixed inset-0 flex justify-center items-center z-[9999] bg-black/30">
      <div
        className="w-[464px] min-h-[22rem] relative bg-neutral-50/50 rounded-xl
        shadow-[0px_15px_30px_rgba(0,0,0,0.10)]
        shadow-[0px_5px_20px_rgba(255,255,255,0.10)]
        shadow-[inset_0px_4px_25px_rgba(255,255,255,0.35)]
        outline outline-1 outline-offset-[-1px] outline-neutral-300/20 backdrop-blur-[30px]
        flex flex-col justify-center items-center gap-8 text-center overflow-hidden p-6"
      >
        <div className="text-black text-2xl font-bold font-figtree leading-7">
          {title}
        </div>

        {message && (
          <p className="text-gray-600 text-base font-figtree">{message}</p>
        )}

        <div className="w-36 h-36 relative flex items-center justify-center">
          <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center">
            <svg
              className="w-16 h-16 text-green-700"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>

        <button
          type="button"
          onClick={onClose}
          className="w-80 h-14 px-6 py-3 bg-green-700 rounded-lg flex justify-center items-center hover:bg-green-800 active:bg-green-900 transition-colors"
        >
          <span className="text-white text-xl font-bold font-figtree leading-normal">
            {buttonLabel}
          </span>
        </button>
      </div>
    </div>
  );

  return createPortal(overlay, document.body);
}

export default SuccessOverlay;
